// ⚠️ MOCK 賠付表 — 以下倍數為暫定佔位值（依常見 ways-pays 遊戲的量級抓的合理範圍），僅供 Mock 可玩流程使用。
//
// 🎯 **真實賠付數值其實找到了**：Data/PayTableData.asset 的 SymbolOdds 確實是空陣列，但 Unity 把
//    「符號 → 連線數 → 倍數」硬編在資訊頁 prefab 的 TMP 文字裡，已逐字抄錄於
//    ../view/hud/info/PayTableGrid.ts 的 `PAY_CELLS`（H1 50/20/8/4/2、H2 6/2.4/1.2/0.6 … LJ 0.4/0.3/0.2/0.1）。
//
// 本檔尚未改用那份真實值，因為它與這裡的模型不同、不是換個數字就好：
//   （1）真實表是**逐符號**的（H1~H7 各不相同），這裡只分 wild/high/low 三級；
//   （2）**只有 H1 有 2 連線賠付**，其餘最少 3 連線 → `MIN_WAYS_REELS` 要改成逐符號下限；
//   （3）真實表**沒有 Wild 自身的賠付**（WW 只做替代），這裡卻給了 Wild 最高倍數。
// 也就是說換表會動到 waysEvaluator 的中獎判定與既有測試，屬獨立一輪工作（僅影響離線 Mock 的贏分金額，
// 連真後端時賠付一律由伺服器計算，不走本檔）。

import type { SymbolTier } from './symbols'

/** ways-to-win 的「連續命中輪數」只會是 MIN_WAYS_REELS(3) 到 MAIN_REEL_COUNT(6)。 */
export type ReelsMatched = 3 | 4 | 5 | 6

const HIGH_TIER_PAYOUTS: Readonly<Record<ReelsMatched, number>> = {
  3: 1,
  4: 4,
  5: 15,
  6: 50,
}

const LOW_TIER_PAYOUTS: Readonly<Record<ReelsMatched, number>> = {
  3: 0.4,
  4: 1.5,
  5: 5,
  6: 15,
}

const WILD_TIER_PAYOUTS: Readonly<Record<ReelsMatched, number>> = {
  3: 3,
  4: 10,
  5: 40,
  6: 150,
}

/** 回傳每個 way 的下注倍率（MOCK 佔位值）；scatter 不走 ways 賠付，回傳 0。 */
export function mockPayoutMultiplier(tier: SymbolTier, reelsMatched: ReelsMatched): number {
  switch (tier) {
    case 'wild':
      return WILD_TIER_PAYOUTS[reelsMatched]
    case 'high':
      return HIGH_TIER_PAYOUTS[reelsMatched]
    case 'low':
      return LOW_TIER_PAYOUTS[reelsMatched]
    case 'scatter':
      return 0
  }
}
